import { defineComponent as _defineComponent } from 'vue'
import { Ref, ref } from 'vue';

import BrandIcon from '@/components/icons/BrandIcon.vue';
import { Notification } from '@/data/datatypes/Notification';
import NavListItem from '@/navigation/NavListItem.vue';

interface Props {
  notification: Notification;
}
interface Emits {
  (e: 'click', event: MouseEvent): void,
  (e: 'deleted'): void,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationNavListItem',
  props: {
    notification: null
  },
  emits: ["click", "deleted"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'click', event: MouseEvent): void,
  (e: 'deleted'): void,
}), expose: any, slots: any, attrs: any }) {





const deleteButtonFocused: Ref<boolean> = ref(false);

function handleClick(event: MouseEvent): MouseEvent {
  emit('click', event);
  emit('deleted');
  return event;
}

function handleDelete(): void {
  //  Delete activity
  emit('deleted');
}

return { __sfc: true,emit, deleteButtonFocused, handleClick, handleDelete, BrandIcon, NavListItem }
}

})